<template>
  <div>
    <el-upload
      ref="upload"
      :class="limit === fileList.length?'no-file':''"
      :auto-upload="true"
      :on-change="handleCrop"
      :before-upload="beforeAvatarUpload"
      :disabled="disabled"
      :file-list="fileList"
      :http-request="uploadImg"
      :accept="accept"
      v-bind="$attrs"
      class="myupload"
      drag
      action="#"
      list-type="picture-card"
    >
      <div class="myupload-div">
        <i class="el-icon-upload" style="font-size: 20px;"/>
        <!-- <img
          style="width: 29px; height: 29px"
          src="@/assets/img/fail.png"
          alt=""
        /> -->
        <span v-if="uploadText" class="upload-text">{{ uploadText }}</span>
      </div>
      <div slot="file" slot-scope="{file}" class="file-list">
        <el-progress v-if="file.percent !=100 " :percentage="file.percent" type="circle"/>
        <template v-else>
          <template v-if="imgPicSuffix.includes(file.name.substring(file.name.lastIndexOf('.')).toLowerCase())">
            <img :src="file.url" alt="" style="width: 100%;height: auto;">
          </template>
          <template v-else>
            {{ file.name }}
          </template>
          <div class="zhezhao">
            <el-link :underline="false" type="primary" @click.stop="handlePreview(file)">{{ $t('预览') }}</el-link>
            <el-link :underline="false" type="primary" @click.stop="handleRemove(file)">{{ $t('删除') }}</el-link>
          </div>
        </template>

      </div>
      <div v-if="isTip" slot="tip" style="margin-top: 5px; font-size: 12px;color: ;">
        <slot name="tip">
          {{ $t('图片只能上传jpg/jpeg/png文件') }}({{ cropperOption.autoCropWidth + '*' + cropperOption.autoCropHeight }}){{ $t(',其他文件请直接上传') }}
        </slot>
      </div>
    </el-upload>
    <cropperImage
      :dialogVisible="showCropper"
      :cropper-option="cropperOption"
      :file-size="fileSize"
      :cropper-style="cropperStyle"
      @close="showCropper = false"
      @uploadCropper="uploadImg"
    />
  </div>
</template>
<script>
import cropperImage from '@/components/cropperImage/index.vue'
import axios from 'axios'
export default {
  components: {
    cropperImage
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 1
    },
    Bucket: {
      type: String,
      default: 'cdb-1305117004'
    },
    Region: {
      type: String,
      default: 'ap-hongkong'
    },
    accept: {
      type: String,
      default: '.jpg,.png,.jpeg'
    },
    uploadText: {
      type: String,
      default: '上传文件'
    },
    isTip: {
      type: Boolean,
      default: true
    },
    apiUrl: {
      type: String,
      default: '/api/common/uploadImg'
    }
  },
  data() {
    return {
      baseUrl: process.env.BASE_API,
      imgPicSuffix: ['.jpg', '.jpeg', '.gif', '.png'],
      fileList: [],
      fileSrcList: [],
      showCropper: false, // 显示裁剪弹窗
      cropperOption: {
        // 裁剪配置
        img: '',
        autoCropWidth: 200,
        autoCropHeight: 200,
        filename: ''
      },
      cropperStyle: {
        // 裁剪框大小
        width: '200px',
        height: '200px'
      },
      fileSize: 1, // 文件限制个数
      cropperData: {},
      filename: ''
    }
  },
  created() {
  },
  methods: {
    init(imgs, width = 100, height = 100) {
      console.log(imgs)
      if (Array.isArray(imgs)) {
        this.fileList = imgs.map(item => {
          return {
            name: item.fileExplainName,
            url: item.filePath,
            id: item.fileId,
            percent: 100
          }
        })
      } else {
        if (imgs) {
          this.fileList = [{
            name: imgs.fileExplainName,
            url: imgs.filePath,
            id: imgs.fileId,
            percent: 100
          }]
        }
      }
      this.cropperOption.autoCropWidth = width
      this.cropperOption.autoCropHeight = height
      this.cropperStyle = {
        width: width * 1.5 + 'px',
        height: height * 1.5 + 'px'
      }
    },
    handlePreview(file) {
      window.open(file.url)
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      this.fileList.splice(index, 1)
      console.log(index)
    },
    handleCrop(file) {
      // 点击弹出剪裁框
      this.$nextTick(() => {
        console.log(this.canCropper, '167>>>>>>>>>>>>>')
        if (this.canCropper) {
          console.log(file)
          this.cropperOption.filename = file.uid + (file.name.substring(file.name.lastIndexOf('.')))
          this.cropperOption.img = window.URL.createObjectURL(file.raw)
          this.showCropper = this.canCropper
        }
      })
    },
    beforeAvatarUpload(file) {
      // 上传前校验
      // const isJPG =
      //   file.type === "image/jpeg" ||
      //   file.type === "image/jpg" ||
      //   file.type === "image/png";
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      // }
      // if (!isLt2M) {
      //   this.$message.error("上传头像图片大小不能超过 2 MB!");
      // }
      // // 校验通过后显示裁剪框
      // this.canCropper = isJPG && isLt2M;
      if (this.imgPicSuffix.includes(file.name.substring(file.name.lastIndexOf('.')).toLowerCase())) {
        this.canCropper = true
      } else {
        this.canCropper = false
      }
      return !this.canCropper
    },
    // 自定义上传方法
    async uploadImg(file, data) {
      const name = file.name || file.file.uid + (file.file.name.substring(file.file.name.lastIndexOf('.')))
      console.log(file)
      const fileFormData = new FormData()
      fileFormData.append('file', file.file || file)
      if (this.$attrs.data) {
        for (const key in this.$attrs.data) {
          if (!this.$attrs.data[key]) {
            this.$message.error('参数不正确')
            this.fileList.splice(this.fileList.length - 1, 1)
            return
          }
          fileFormData.append(key, this.$attrs.data[key])
        }
      }
      // fileFormData.append("type", 0);
      // 移除上传组件带来的bug
      // document.getElementsByTagName('body')[0].removeAttribute('style')
      this.cropperData.iconUrl = data
      this.showCropper = false
      this.fileList.push({
        name: name,
        url: data,
        percent: 0
      })
      axios.post(this.apiUrl, fileFormData, {
        // headers: {
        //   'Content-Type': 'multipart/form-data',
        //   Authorization: this.$store.getters.access_token
        // },
        onUploadProgress: (progressEvent) => {
          // 处理原生进度事件
          console.log(progressEvent)
          const percent = Number(progressEvent.loaded / progressEvent.total * 100).toFixed(0)
          this.$set(this.fileList[this.fileList.length - 1], 'percent', Number(percent))
        }
      }).then(res => {
        console.log(res)
        if (res.data.ReturnCode === 200) {
          this.$set(this.fileList[this.fileList.length - 1], 'url', res.data.Data)
          // this.$set(this.fileList[this.fileList.length - 1], 'name', res.data.data.fileName)
          // this.$set(this.fileList[this.fileList.length - 1], 'id', res.data.data.fileId)

          this.$emit('change', this.limit > 1 ? this.fileList : this.fileList[0])
        } else {
          this.$message.error(res.data.Data)
          this.fileList.splice(this.fileList.length - 1, 1)
        }
      })
      // this.cos.uploadFile({
      //   Bucket: this.Bucket, /* 填写自己的 bucket，必须字段 */
      //   Region: this.Region,     /* 存储桶所在地域，必须字段 */
      //   Key: name,              /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */
      //   Body: file.file||file, // 上传文件对象
      //   SliceSize: 1024 * 1024 * 5,     /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */
      //   onProgress: (progressData) => {
      //     console.log(JSON.stringify(progressData));
      //     let percent = Number(progressData.percent*100).toFixed(0)
      //     this.$set(this.fileList[this.fileList.length-1], 'percent', Number(percent))
      //   }
      // }, (err, ossData) => {
      //     if (err) {
      //       console.log('上传失败', err);
      //       this.$message.error(this.$t('上传失败'))
      //       this.fileList.splice(this.fileList.length-1, 1)
      //     } else {
      //       this.$message.success(this.$t('上传成功'))
      //       this.$emit('change', this.limit > 1?this.fileList.map(item => item.name):this.fileList[0].name)
      //     }
      //   }
      // )
    }
  }
}
</script>
<style lang="scss" scoped>
.myupload{
  .file-list{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .zhezhao{
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      background-color: rgba($color: #000000, $alpha: 0.5);
      font-size: 14px;
      opacity: 0;
      a{
        color: white;
      }
    }
    &:hover{
      .zhezhao{
        opacity: 1;
      }
    }
  }
  ::v-deep{
    .el-upload-list{
    }
    .el-upload-list__item{
      &.is-success {

      }
    }
    .el-upload-dragger{
      width: 100%;
      height: 100%;
    }
  }
  &.no-file{
    ::v-deep{
      .el-upload--picture-card{
        display: none;
      }
    }
  }
  .myupload-div{
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: inherit;
    .el-icon-upload{
      margin: 0;
      line-height: initial;
    }
    .upload-text{
      line-height: initial;
    }
  }
}
</style>
